<template>
    <header class="header container" >
        <img :src="image" :style="getHeight" alt="">
    </header>
</template>
<script>


    export default {
        props: ['image', 'height'],
      computed: {
        getHeight(){
            return  this.height? 'height: '+ this.height + 'px;': 'height: 400px';
      }
      },

        mounted() {


        }
    }

</script>

<style scoped>
    /* HEADER */
    .header {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 0;

        display: flex;
        flex-wrap: wrap;

        z-index: 0;


    }
    .header img {
        margin: auto;
        margin-top: 169px;
        object-fit: cover;
        width: 100%;
    }

    .header:after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        /*background: #26282b;*/
        /*background: -moz-linear-gradient(161deg, #26282b 0%, #26282b 49%, #9f8054 100%);*/

        opacity: 0.65;
    }

</style>